import {useMemo} from "react";

import type {ListingGroup} from "../../models/listingGroup";

export default function useFilteredListingGroup(listingGroups: ListingGroup[], query: string) {
    return useMemo(() => {
        const filteredQuery = query.toLowerCase().trim();
        return listingGroups.filter(listingGroup => {
            return listingGroup.name.toLowerCase().includes(filteredQuery);
        });
    }, [listingGroups, query]);
}
